import * as React from 'react';

import { ICareerVacancy } from '../../store/models';
import { VacancyItem } from './vacancyItem';

interface IProps {
    vacancies: ICareerVacancy[];
}

export const Vacancies: React.FC<IProps> = ({ vacancies }) => {
    return (
        <div className="vacancies">
            {vacancies.map(vacancy => (
                <VacancyItem key={vacancy.id} vacancy={vacancy} />
            ))}
        </div>
    );
};
